module.exports = __webpack_public_path__ + "img/Weapon_74.c7dc45c7.png";